
























import Vue from 'vue'
import ContactForm from '@/components/ContactForm.vue'

export default Vue.extend({
  name: 'Contact',
  beforeMount() {
    document.body.scrollTop = 0
  },
  components: {
    ContactForm
  }
})
